module.exports = __webpack_public_path__ + "img/cream-soda.7a8c07a4.svg";